import React from 'react';

import { IPasswordPolicy } from '~src/authentication/models/validation/IPasswordPolicy';

export namespace ValidationHelpers {
  export const USERNAME_REGEXP: RegExp = new RegExp('[;,]');
  export const INVALID_USERNAME_CHARS_STR = ' ; , ';

  export function createPasswordPolicyErrorMessageSectionFor(failedPolicies: IPasswordPolicy[]): JSX.Element {
    if (!failedPolicies || !failedPolicies.length) {
      return null;
    }

    return (<span data-tb-test-id="passwordPolicyMessages">
                {failedPolicies.map((failedPolicy, index) => {
                  return <div key={index} className="tb-error-text tb-form-error" role="alert" data-tb-test-id={failedPolicy.getTestId()}>
                    {failedPolicy.getErrorMessage()}
                  </div>;
                })}
              </span>);
    }

  export function hasInvalidUsername(userName: string): boolean {
    return userName.length > 0 && USERNAME_REGEXP.test(userName);
  }

  export function hasNonMatchingPasswords(password: string, confirmPassword: string): boolean {
    return (password.length > 0 && confirmPassword.length > 0 && password !== confirmPassword);
  }

  export function isLocalUserInputsValid(
                            userName: string,
                            displayName: string,
                            password: string,
                            confirmPassword: string,
                            checkPassword: boolean,
                            passwordIsValid: boolean): boolean {
    if (userName.length > 0 &&
        displayName.length > 0 &&
        !this.hasInvalidUsername(userName)) {
        if (checkPassword) {
          const hasPassword = password.length > 0;
          const hasConfirmedPassword = confirmPassword.length > 0;

          return hasPassword && hasConfirmedPassword && !this.hasNonMatchingPasswords(password, confirmPassword) && passwordIsValid;
        }
        return true;
    }
    return false;
  }
}
